
import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TestRoutingModule } from './test-routing.module';
import { TestCaseComponent } from './test-case/test-case.component';
import { TestStepComponent } from './test-step/test-step.component';
import { SimpleModalModule } from 'ngx-simple-modal';
import { StepFormComponent } from './test-step/step-form/step-form.component';
import {MatExpansionModule} from '@angular/material/expansion';

// import { MatSlideToggleModule,
//   MatMenuModule, MatButtonModule, MatIconModule,
//   MatCardModule, MatSidenavModule, MatSliderModule, MatCheckboxModule, MatTabsModule, MatDialogModule, MatExpansionModule } from '@angular/material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; 
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationDialogComponent } from './test-step/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './test-step/confirmation-dialog.service';
// import { NgxGraphModule } from '@swimlane/ngx-graph';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
import {NgxPaginationModule} from 'ngx-pagination';
import { UpdateFormComponent } from './test-case/update-form/update-form.component';
import { HistoryComponent } from './history/history.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ProjectModule } from '../project/project.module';
import { SharedModule } from '../shared/shared.module';
import { RunManagementComponent } from './run-management/run-management.component';
import { AngularMaterialModule } from '../angular-material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { RecordDataComponent } from './test-step/record-data/record-data.component';
import { RecordTestCaseConfirmationComponent } from './test-step/record-test-case-confirmation/record-test-case-confirmation.component';
import { LayoutModule } from '../layout/layout.module';
import { WheelDirective } from './wheel.directive'
import { FreeDraggingDirective } from "./free-dragging.directive";
import { FlowChartComponent } from './test-step/flow-chart/flow-chart.component';

import { CustomStepComponent } from './test-step/flow-chart/custom-step/custom-step.component';
import { FormStepComponent } from './test-step/flow-chart/form-step/form-step.component';
import { FormStep1Component } from './test-step/flow-chart/form-step1/form-step1.component';
import { FormStep2Component } from './test-step/flow-chart/form-step2/form-step2.component';
import { FormStep3Component } from './test-step/flow-chart/form-step3/form-step3.component';
import { FormStep4Component } from './test-step/flow-chart/form-step4/form-step4.component';
import { NestedFlowComponent } from './test-step/flow-chart/nested-flow/nested-flow.component';
import { RouteStepComponent } from './test-step/flow-chart/route-step/route-step.component';
import { NgFlowchartModule } from 'projects/ng-flowchart/src/lib/ng-flowchart.module';

// import { ProjectComponent } from '../project/project.component';

@NgModule({
    declarations: [TestCaseComponent,
        TestStepComponent,
        StepFormComponent,
        ConfirmationDialogComponent,
        UpdateFormComponent,
        HistoryComponent,
        RunManagementComponent,
        RecordDataComponent,
        RecordTestCaseConfirmationComponent,
        WheelDirective,
        FreeDraggingDirective,
        FlowChartComponent,
        CustomStepComponent,
        RouteStepComponent,
        NestedFlowComponent,
        FormStepComponent,
        FormStep1Component,
        FormStep2Component,
        FormStep3Component,
        FormStep4Component,
        //  ProjectComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        NgxPaginationModule,
        // AngularMaterialModule,
        // NgxGraphModule, 
        // NgxChartsModule,
        TestRoutingModule,
        MatDialogModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatCheckboxModule,
        MatTabsModule,
        NgbModule,
        NgMultiSelectDropDownModule,
        ProjectModule,
        SharedModule,
        LayoutModule,
        MatExpansionModule,
        NgFlowchartModule,
        SimpleModalModule.forRoot({ container: 'modal-container' })
    ],
    providers: [ConfirmationDialogService],
    // entryComponents: [StepFormComponent],
    bootstrap: [TestStepComponent]
})
export class TestModule { }
